function isSameHost(urlText: string) {
    return !urlText.startsWith('http') || new URL(urlText).host === window.location.host;
}

/**
 * If an analytics event is happening on the same host, transform the URL to just the pathname.
 *
 * @param {string} urlText the textual URL to be parsed by the URL constructor
 */
export function transformToAnalyticsUrl(urlText: string) {
    try {
        if (urlText.startsWith('http') && isSameHost(urlText)) {
            return new URL(urlText).pathname;
        }
    } catch (error) {
        return urlText;
    }
}
